
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-business-funders",
      function () {
        return require("private-next-pages/our-business-funders/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-business-funders"])
      });
    }
  